import Toast from "./Toast.js?r=18";
import OrderForm from './OrderForm.js?r=75';

const productFormEl = document.getElementById('product-form');
const orderForm = new OrderForm(productFormEl);

const inputQuantity = document.querySelector('input[name="quantity"]');
const btnAddToCart = document.querySelector('button.add-to-cart');

const variantRadios = Array.from(
  document.querySelectorAll('#variant-selector input[type="radio"][name="id"]')
);

const urlVariantId = new URLSearchParams(window.location.search).get('variant');

function getSelectedVariantRadio() {
  for (const radio of variantRadios) {
    if (radio.checked) return radio;
  }
  return null;
}

function getRadioByVariantId(variantId) {
  if (!variantId) return null;
  for (const radio of variantRadios) {
    if (radio.value === variantId) return radio;
  }
  return null;
}

function setAddToCartEnabled(isEnabled) {
  if (!btnAddToCart) return;
  if (isEnabled) {
    btnAddToCart.classList.remove('disable');
    btnAddToCart.removeAttribute('disabled');
  } else {
    btnAddToCart.classList.add('disable');
    btnAddToCart.setAttribute('disabled', 'disabled');
  }
}

function applySelectedVariantState(radio) {
  if (!radio) return;

  const inventory = Number.parseInt(radio.dataset.inventory ?? '', 10);
  const hasInventory = Number.isFinite(inventory) && inventory > 0;
  const isAvailable = String(radio.dataset.available).trim().toLowerCase() === 'true' && hasInventory;

  const numberInput =
    orderForm && orderForm.input && typeof orderForm.input.setValue === 'function'
      ? orderForm.input
      : null;

  if (inputQuantity) {
    const max = hasInventory ? inventory : 1;
    inputQuantity.setAttribute('max', String(max));

    // Don't disable the input (disabled fields aren't serialized). Make it readonly when OOS.
    inputQuantity.readOnly = !isAvailable;
    inputQuantity.setAttribute('aria-disabled', String(!isAvailable));

    if (!isAvailable) {
      if (numberInput) numberInput.setValue(1);
      else inputQuantity.value = '1';
    } else {
      const current = Number.parseInt(inputQuantity.value || '1', 10);
      if (!Number.isFinite(current) || current <= 0) {
        if (numberInput) numberInput.setValue(1);
        else inputQuantity.value = '1';
      } else if (current > inventory) {
        if (numberInput) numberInput.setValue(inventory);
        else inputQuantity.value = String(inventory);
      }
    }
  }

  setAddToCartEnabled(isAvailable);

  if (orderForm?.input?.update) orderForm.input.update();
}

// Update UI on user selection (single delegated listener).
if (productFormEl) {
  productFormEl.addEventListener('change', (ev) => {
    const target = ev.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.type !== 'radio' || target.name !== 'id') return;
    applySelectedVariantState(target);
  });
}

// URL variant should always win, even if OOS.
const initialRadio = getRadioByVariantId(urlVariantId) ?? getSelectedVariantRadio();
if (initialRadio) {
  initialRadio.checked = true;
  applySelectedVariantState(initialRadio);
}

//add to wishlist reload
function flushCache(){
  var formData = new FormData();
  formData.append("attributes[cache_time]", Date.now());
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .catch(() => {});
}

const chkWishList = document.getElementById('chk-wishlist');
const btnWishlists = document.querySelectorAll('.btn-wishlist');
[...btnWishlists].forEach(btnWishlist =>{
  btnWishlist.addEventListener('click', evt => {
    evt.preventDefault();
    
    btnWishlist.classList.add('disabled');
    const btn_action = btnWishlist.getAttribute('data-action')
    switch(btn_action){
      case "add":
      case "remove":
        const url = btnWishlist.getAttribute('href') + '.json?fetch=true';
        const message = btnWishlist.getAttribute('data-flash-message');
        fetch(url).then((res)=>{
          res.json().then(data=>{
            flushCache();
            Toast.show(message,  "toast", false);
            if(data.action === 'wishlist_add'){
              chkWishList.setAttribute('checked', 'checked');
            }else{
              chkWishList.removeAttribute('checked');
            }
            btnWishlist.classList.add('disabled');
            
          });
        });
        break;
  
      case "login":
        {
          const formData = new FormData();
          formData.append("attributes[login_return]", window.login_return);
          fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData,
          credentials: "include"
          }).then(()=>{
            window.location = '/account/login';
          });
        }
        break;
      default:
        //nothing to do
    }
  
  });
})